/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  var $ezTocContainer = $("#ez-toc-container");
  var $toc = $(".ez-toc-list");

  if ($toc.length === 0) {
    return;
  }

  var $tocHeight = $(".ez-toc-list").outerHeight();
  var listHeight = $(".ez-toc-list li:first-child").outerHeight();
  var $tocTitle = $(".ez-toc-title-toggle");

  $tocTitle.text("目次");

  $ezTocContainer.addClass("active");
  $tocTitle.addClass("active");
  $toc.css("height", $tocHeight);

  $(".ez-toc-title-container").on("click", function () {
    $ezTocContainer.toggleClass("active");
    $tocTitle.toggleClass("active");

    if (Math.floor($toc.height()) !== Math.floor(listHeight)) {
      $toc.animate({ height: listHeight }, 500);
    } else {
      $toc.animate({ height: $tocHeight }, 500);
    }
  });
});
